const setSelectedStatus = (state: any, status: string) => {
  const newSelections = {
    ...state.selections,
    selectedStatus: status,
  }

  Object.assign(state, { selections: newSelections })
}

export default {
  setSelectedStatus,
}
